import React, { useEffect, useState } from 'react';
import { UserManagementImage } from '../../../assets/images';
import {
  CommonHeader,
  ContentArea,
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader
} from '../../../components/commons';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import { getAllFinacUsersAction, resetFinacUsersList, resetSession } from '../../../redux/auth';
import { assignGroupToUserAction, getAllUserGroupsAction, getAssignedGroupToUserAction, resetAssignedGroupListCount, resetUserManagementError, resetUserManagementSuccess } from '../../../redux/userManagement';
import { AssignedGroupListType, UserGrouptype } from '../../../redux/userManagement/userManagementTypes';
import { GROUP_ASSIGNED_TO_USER_LIST_HEADERS } from '../../../constant/tableHeadersConstants/userManagementConstants/userGroupListConst';
import { assignGroupToUserType, GetAllUserGroupPayloadType, getAssignedGroupToUserPayloadType } from '../../../commonTypes/userManagementTypes';
import { toast, Toaster } from 'react-hot-toast';
import useDebounce from '../../../customHooks/useDebounce';
import { AddIcon, SearchIcon } from '../../../components/Icon';
import { Col, Row } from 'reactstrap';
import AssignedGroupTableData from '../../../components/UserManagement/AssignedGroupToUserTable/AssignedGroupTableData';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';
import { GetAllFinacUserPayloadType} from '../../../commonTypes/authTypes';
import { Link } from 'react-router-dom';
import InfiniteLoader from '../../../components/commons/InfiniteLoader/InfiniteLoader';
import ScrollToTop from '../../../components/commons/ScrollToTop';

type AppProps = {
  token: string | null;
  finacUsersList: any;
  success: number | null;
  fetching: boolean;
  error: string | null;
  statusCode: number | null;
  history?: any;
  userGroupList: []| UserGrouptype[] ;
  assignedGroupList:[] | AssignedGroupListType[];
  assignedGroupListCount:string|number;
  dispatchResetSession: () => void;
  dispatchResetUserManagementError: () => void;
  dispatchResetUserManagementSuccess: () => void;
  dispatchResetFinacUsersList: () => void;
  dispatchResetAssignedGroupListCount: () => void;
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => void,
  dispatchAssignGroupToUser: (data: assignGroupToUserType) => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void | undefined;
  dispatchGetAssignedGroupToUser:(token:any)=> void|undefined
}

const AssignGroups = ({
  token,
  success,
  statusCode,
  error,
  fetching,
  assignedGroupList,
  assignedGroupListCount,
  dispatchResetSession,
  dispatchResetUserManagementError,
  dispatchResetUserManagementSuccess,
  dispatchGetAssignedGroupToUser,
  dispatchResetFinacUsersList,
  dispatchResetAssignedGroupListCount
}: AppProps) => {
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [searchData, setSearchData] = useState<string>("");
  const [offset,setOffset] =useState(0);
  const [limit, setLimit] = useState(20);
  const [searchClear,setSearchClear] = useState(false);
  const [data,setData]= useState<any>([]);
 
  //========== User Management ==========//
	const [isAddAssignGroupsPresent, setIsAddAssignGroupsPresent] = useMenuCheck();
	const [isEditAssignGroupsPresent, setIsEditAssignGroupsPresent] = useMenuCheck();
  //====================//
  useEffect(() => {
    dispatchResetUserManagementError();
    dispatchResetUserManagementSuccess();
    dispatchResetFinacUsersList();
    dispatchResetAssignedGroupListCount();
    setIsAddAssignGroupsPresent("Add Assign User Groups to Users","menu")
    setIsEditAssignGroupsPresent("Edit Assign User Groups to Users","menu")
  }, []);

  const fetchNewData = (offset: number, limit: number, search_term = "") => {
    if (token) {
      setSearchClear(true)
      let finalData = {
        token,
        offset,
        limit,
        search_term:search_term
      };

      if (offset === 0) {
                setOffset(0)
                dispatchGetAssignedGroupToUser(finalData);
              }
              else {
                setOffset(0);
             }
    }
  };


  useEffect(() => {
   if (assignedGroupList?.length === 0) {
          setData(assignedGroupList)
          }
             if (offset > 0) {
            
            setData((prv:any)=>[...prv,...assignedGroupList])
          }
          else {
           
            setData(assignedGroupList)
          }
    }, [assignedGroupList]);
  
   useEffect(() => {
     if (searchClear) {
          let finalData = {
            token,
             search_term: searchData,
        limit,
        offset,
          }
        if(searchData?.length===0){
          dispatchGetAssignedGroupToUser(finalData);
          setOffset(0)
        }
     }
    }, [searchClear, searchData]);
  
  
    useEffect(() => {
      if (token) {
        let finalData = {
          token,
          search_term:searchData,
          offset,
          limit,
        };
        if (offset < +assignedGroupListCount) {
          dispatchGetAssignedGroupToUser(finalData);
        }
        else if(offset===0 && assignedGroupListCount===0){
          dispatchGetAssignedGroupToUser(finalData);
        }
      }
    },[offset])

   useDebounce(
    () => {
      if (searchData) {
        fetchNewData(0, 20, searchData);
      }
    },
    500,
    [searchData]
  );


  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
  };

    const onScroll = () => {
        const scrollTop = document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        
        if (Math.ceil( 75/100*scrollHeight)<=scrollTop + clientHeight) {
        if (assignedGroupList?.length>0) {
          setOffset(offset + limit)
        }
      }
    }
    
      useEffect(() => {
        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    },[assignedGroupList])

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserManagementError();
            }}
          />
        )
      }
    }
    else if (success === 1) {
      dispatchResetUserManagementSuccess()
      toast.success(successMessage, {
        duration: 2000
      });
    }
    return false;
  }

  return (
    <> 
    <div className="row">
        <div className="col-md-6">
          <CommonHeader
            title='Assign Group To User'
          />
        </div>
        <div className="col-md-6">
          <div className="d-flex flex-row justify-content-end mr-5">
                <Link
                className="btn btn-primary"
                to={{
                  pathname: "/user-management/assign-groups-list/assign-groups",
                }}
              >
                  <AddIcon /> Assign Group
                </Link>
          </div>
        </div>
      </div> 

    <ContentArea>
      {<>
      <Row>
       <Col lg={4}></Col>
        <Col
          lg={8}
          className="text-right d-flex flex-row"
          style={{ justifyContent: "flex-end" }}
        >
          <div className="mr-3 w-auto position-relative">
            <span style={{ position: "absolute", top: "8px", left: "13px" }}>
              <SearchIcon />
            </span>
            <input
              className="form-control"
              type="text"
              placeholder="Search"
              onChange={(e: any) => handleSearch(e)}
              style={{ paddingLeft: "35px" }}
            />
          </div>
        </Col>
        
      </Row>

      {fetching&&offset===0 ? (
        <TableLoader Rows={10} ColumnPerRow={5} />
      )  : (
        <div className="row">
            <div className="col-md-12">
              <div className="table-bordered">
                <table className="table table-striped">
                 {assignedGroupList?.length!==0 && <thead className='text-center'>
                    <TableHeader
                      tableHeader={GROUP_ASSIGNED_TO_USER_LIST_HEADERS}
                    />
                  </thead>}
                  <tbody>
                    <AssignedGroupTableData
                      tableHeaders={GROUP_ASSIGNED_TO_USER_LIST_HEADERS}
                      data={data}
                    />
                    <div style={{display:fetching?"none":"inline"}}><ScrollToTop/></div>
                    {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                  </tbody>
                </table>
              </div>
            </div>
        </div>
      )}
      </>}

     {assignedGroupList?.length===0 && <>
        <EmptyListPage
              title="No User Groups Found!"
              text="Create a user group and manage the list here"
              buttonTitle="+ Create User Group"
              showLinkButton
              link={`/user-management/user-groups/add-user-group`}
              image={UserManagementImage}
              imageWidth="30%"
            />
        </>}
        
      </ContentArea>
      {handleErrorModal()}
      <Toaster />
    </>
  )
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  finacUsersList: state.auth.finacUsersList,
  fetching: state.userManagement.fetching,
  success: state.userManagement.success,
  statusCode: state.userManagement.statusCode,
  error: state.userManagement.error,
  userGroupList: state.userManagement.userGroupList,
  assignedGroupList: state.userManagement.assignedGroupList,
  assignedGroupListCount:state.userManagement.assignedGroupListCount
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetUserManagementError: () => dispatch(resetUserManagementError()),
  dispatchResetUserManagementSuccess: () => dispatch(resetUserManagementSuccess()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchResetAssignedGroupListCount: () => dispatch(resetAssignedGroupListCount()),
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => dispatch(getAllUserGroupsAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
  dispatchAssignGroupToUser: (data: assignGroupToUserType) => dispatch(assignGroupToUserAction(data)),
  dispatchGetAssignedGroupToUser:(data:getAssignedGroupToUserPayloadType)=>dispatch(getAssignedGroupToUserAction(data))
})

export default connect(mapStateTopProps, mapDispatchToProps)(AssignGroups);